export const PIXEL_ID = '1545009850674181'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

let initialized = false

function isPreviewIframe() {
  if (typeof window === 'undefined') return true
  try {
    // Skip pixel inside the Magic Patterns preview / any cross-origin iframe
    return window.self !== window.top
  } catch {
    return true
  }
}

export function initMetaPixel() {
  if (initialized) return
  if (typeof window === 'undefined') return
  if (isPreviewIframe()) return
  if (window.fbq) {
    initialized = true
    return
  }

  try {
    ;(function (f: any, b: Document, e: string, v: string) {
      let n: any
      if (f.fbq) return
      n = f.fbq = function () {
        // eslint-disable-next-line prefer-rest-params
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      t.onerror = () => {
        /* silently ignore script load failures (CSP, ad-blockers, sandboxed iframes) */
      }
      const s = b.getElementsByTagName(e)[0]
      s.parentNode?.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )

    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')
    initialized = true
  } catch {
    // Never let pixel init break the page
  }
}

export function trackEvent(event: string, data?: Record<string, unknown>) {
  try {
    if (typeof window === 'undefined' || !window.fbq) return
    window.fbq('track', event, data)
  } catch {
    // ignore
  }
}
